import React from 'react'

export const lazyWithRetries: typeof React.lazy = (importer) => {
  const retryImport = async () => {
    try {
      return await importer()
    } catch (error) {
      console.error('Lazy load error', error)
      // retry 5 times with 2 second delay and backoff factor of 2 (2, 4, 8, 16, 32 seconds)
      for (let i = 0; i < 5; i++) {
        // oxlint-disable-next-line no-await-in-loop -- sequential backoff retries
        await new Promise((resolve) => setTimeout(resolve, 1000 * 2 ** i))
        // this assumes that the exception will contain this specific text with the url of the module
        // if not, the url will not be able to parse and we'll get an error on that
        // eg. "Failed to fetch dynamically imported module: https://example.com/assets/Home.tsx"
        try {
          // oxlint-disable-next-line no-await-in-loop -- sequential retry attempts
          return await importer()
        } catch (_) {
          console.log('Retry import')
        }
      }
      throw error
    }
  }
  return React.lazy(retryImport)
}
